import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import VoyahDreamSpecMid from '../../components/VoyahDreamSpecMid/VoyahDreamSpecMid'

const VoyahDreamSpecifications = () => {
  return (
    <div className='vdsnav'>
      <Navbar/>
      <VoyahDreamSpecMid/>
      <Footer/>

    </div>
  )
}

export default VoyahDreamSpecifications
